import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "15",
  fill: "none",
  viewBox: "0 0 14 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.255 1.086v1.167h3.5V1.086h1.167v1.167h2.333c.322 0 .583.26.583.583v9.333a.583.583 0 0 1-.583.584h-10.5a.583.583 0 0 1-.583-.584V2.836c0-.322.261-.583.583-.583H4.09V1.086zm6.417 5.833H2.339v4.667h9.333zm-7.583-3.5h-1.75v2.334h9.333V3.419h-1.75v1.167H8.755V3.419h-3.5v1.167H4.09z"
    }, null, -1)
  ]))]))
}
export default { render: render }